<div *ngIf="planUsuario && planUsuario.pagado && !planUsuario.activo && !user.configured && type != 'extend' && type != 'change' && type != 'certifications'; else planNoPagado" class="card border-width-3 border-radius-0 border-color-hover-dark" data-plugin-sticky data-plugin-options="{'minWidth': 991, 'containerSelector': '.row', 'padding': {'top': 85}}">
	<div class="card-body">
		<h4 class="font-weight-bold text-3 mb-3">El plan ya se encuentra pagado</h4>
		<table class="shomt-3" style="width: 100%" *ngIf="planSeleccionado">
			<tbody>
				<tr>
					<td>
						<strong class="d-block text-color-dark line-height-1 font-weight-semibold" id="nombrePlan">Plan {{ planSeleccionado.nombre }}</strong>
						<span class="text-1">Costo Mensual</span>
					</td>
					<td class="align-top">
						<span class="amount font-weight-medium text-color-grey" id="precioPlan">${{ planSeleccionado.precio | number : "1.0-2" : "es" }}</span>
					</td>
				</tr>
				<tr>
					<td>
						<strong class="text-color-dark">Forma de Pago</strong>
					</td>
					<td>
						<strong><span class="amount font-weight-medium" id="textPlanes">Webpay</span></strong>
					</td>
				</tr>
				<tr>
					<td colspan="2">
						<hr />
					</td>
				</tr>
				<tr *ngIf="resumenCuenta?.proporcional > 0">
					<td>
						<strong class="text-color-dark">Proporcional ({{ resumenCuenta.differenceInDays }} días):</strong>
					</td>
					<td>
						<strong
							>$<span class="amount font-weight-medium" id="textPlanes">{{ resumenCuenta.proporcional | number : "1.0-2" : "es" }}</span></strong
						>
					</td>
				</tr>
				<tr>
					<td>
						<strong class="text-color-dark">Planes:</strong>
					</td>
					<td>
						<strong
							>$<span class="amount font-weight-medium" id="textPlanes">{{ planUsuario.totalPlanes | number : "1.0-2" : "es" }}</span></strong
						>
					</td>
				</tr>
				<tr>
					<td>
						<strong class="text-color-dark">Certificaciones (P. único):</strong>
					</td>
					<td>
						<strong
							>$<span class="amount font-weight-medium" id="textCertificaciones">{{ planUsuario.totalCertificacion | number : "1.0-2" : "es" }}</span></strong
						>
					</td>
				</tr>
				<tr>
					<td colspan="2"></td>
				</tr>
				<tr>
					<td>
						<strong class="text-color-dark">Subtotal:</strong>
					</td>
					<td>
						<strong
							>$<span class="amount font-weight-medium" id="textSubtotal">{{ planUsuario.subTotal | number : "1.0-2" : "es" }}</span></strong
						>
					</td>
				</tr>
				<tr>
					<td>
						<strong class="text-color-dark" id="textDescuentoPorc">Descuento:</strong>
					</td>
					<td>
						<strong
							>$<span class="amount font-weight-medium" id="textDescuento">{{ planUsuario.descuento | number : "1.0-2" : "es" }}</span></strong
						>
					</td>
				</tr>
				<tr>
					<td>
						<strong class="text-color-dark">Neto:</strong>
					</td>
					<td>
						<strong
							>$<span class="amount font-weight-medium" id="textNeto">{{ planUsuario.neto | number : "1.0-2" : "es" }}</span></strong
						>
					</td>
				</tr>
				<tr>
					<td>
						<strong class="text-color-dark">IVA:</strong>
					</td>
					<td>
						<strong
							>$<span class="amount font-weight-medium" id="textIVA">{{ planUsuario.iva | number : "1.0-2" : "es" }}</span></strong
						>
					</td>
				</tr>
				<tr class="total">
					<td>
						<strong class="text-color-dark">Total:</strong>
					</td>
					<td>
						<strong class="text-color-dark"
							>$<span class="amount text-color-dark text-5" id="textTotal">{{ planUsuario.total | number : "1.0-2" : "es" }}</span></strong
						>
					</td>
				</tr>
			</tbody>
		</table>
	</div>
</div>
<ng-template #planNoPagado>
	<div class="card border-width-3 border-radius-0 border-color-hover-dark" data-plugin-sticky data-plugin-options="{'minWidth': 991, 'containerSelector': '.row', 'padding': {'top': 85}}">
		<div class="card-body" style="position: relative;">
			<h4 class="font-weight-bold text-uppercase text-4 mb-3">RESUMEN</h4>

			<div class="resumen-block mb-4" *ngIf="planSeleccionado || (type === 'certifications' && resumenCuenta)" style="position: relative;">
				<div class="loading-overlay loading-resumen" [attr.data-testid]="type === 'certifications' ? 'certification-summary-loading' : 'payment-summary-loading'" *ngIf="isLoading || modalLoading">
					<img src="./assets/deployAssets/icons/loader_16x16.gif" />
				</div>
				<div id="wizStepCertificacion">
					<!-- Header resumen -->
					<div class="d-flex justify-content-between align-items-center resumen-header" *ngIf="type !== 'certifications' && (nmesesAntiguo > 0 || type != 'extend') && planSeleccionado">
						<div>
							<strong class="d-block text-color-dark line-height-1 font-weight-semibold" id="nombrePlan">Plan {{ planSeleccionado?.nombre || '' }}</strong>
							<span class="text-1">Costo Mensual</span>
						</div>
						<div>
							<span class="amount font-weight-medium text-color-grey" id="precioPlan">${{ planSeleccionado?.precio | number : "1.0-2" : "es" }}</span>
						</div>
					</div>
					<div class="d-flex justify-content-between align-items-center mt-2" *ngIf="type !== 'certifications' && nmeses > nmesesCorte && nmesesNuevo > 0 && type == 'extend'">
						<div>
							<strong class="d-block text-color-dark line-height-1 font-weight-semibold" id="nombrePlan">Plan {{ planNuevo.nombre }} (Nuevo)</strong>
							<span class="text-1">Costo Mensual</span>
						</div>
						<div>
							<span class="amount font-weight-medium text-color-grey" id="precioPlan">${{ planNuevo.precio | number : "1.0-2" : "es" }}</span>
						</div>
					</div>

					<!-- Certificación-->
					<div class="mt-3" *ngIf="type !== 'certifications'">
						<strong class="d-block text-color-dark mb-2">
							Certificación
							<i
								class="fa fa-question-circle ml-1"
								ngbTooltip="¿Cuándo la necesitas? La certificación ante el SII habilita la emisión de DTE con tu empresa. Si ya estás certificado, puedes elegir la opción por tu cuenta. Si el plan elegido lo permite, la opción incluida cubre los documentos básicos marcados sin costo."
								container="body"></i>
						</strong>

						<div class="form-group row mx-auto" style="align-items: baseline">
							<div class="custom-control custom-radio custom-control-inline">
								<input type="radio" id="radio1" class="custom-control-input" name="certificacionPropia" [checked]="tipoCertificacion == 'propia'" value="propia" (change)="updateCertificacion($event.target.value)" />
								<label class="custom-control-label" for="radio1">Certificaré por mi cuenta / Estoy certificado</label>
							</div>
							<div *ngIf="isIndependiente && nmeses >= 12" class="custom-control custom-radio custom-control-inline">
								<input type="radio" id="radio2" name="certificacionPropia" class="custom-control-input" [checked]="tipoCertificacion == 'incluida'" value="incluida" (change)="updateCertificacion($event.target.value)" />
								<label class="custom-control-label" for="radio2">Incluida con el plan</label>
							</div>
							<div *ngIf="!isIndependiente && nmeses >= 6" class="custom-control custom-radio custom-control-inline">
								<input type="radio" id="radio2" name="certificacionPropia" class="custom-control-input" [checked]="tipoCertificacion == 'incluida'" value="incluida" (change)="updateCertificacion($event.target.value)" />
								<label class="custom-control-label" for="radio2">Incluida con el plan</label>
							</div>
							<div *ngIf="isIndependiente && nmeses < 12" class="custom-control custom-radio custom-control-inline">
								<input type="radio" id="radio3" name="certificacionPropia" class="custom-control-input" [checked]="tipoCertificacion == 'agregar'" value="agregar" (change)="updateCertificacion($event.target.value)" />
								<label class="custom-control-label" for="radio3">Quiero agregar la certificación</label>
							</div>
							<div *ngIf="!isIndependiente && nmeses < 6" class="custom-control custom-radio custom-control-inline">
								<input type="radio" id="radio3" name="certificacionPropia" class="custom-control-input" [checked]="tipoCertificacion == 'agregar'" value="agregar" (change)="updateCertificacion($event.target.value)" />
								<label class="custom-control-label" for="radio3">Quiero agregar la certificación</label>
							</div>
						</div>
					</div>

					<!-- Certificaciones adicionales -->
				<div id="groupCertificaciones" *ngIf="tipoCertificacion != 'propia' && type !== 'certifications'">
						<div class="d-flex flex-column">
							<div *ngFor="let cert of certificaciones" class="d-flex align-items-center text-color-grey mb-0" style="justify-content: space-between">
								<label for="{{ cert.nombre }}"> <input id="{{ cert.nombre }}" type="checkbox" class="me-2" name="{{ cert.nombre }}" [checked]="cert.solicitada" (change)="updateModelCertificacion(cert)" [disabled]="modalLoading" /> {{ cert.nombre }} </label>
								<label id="valorFactElect">{{ cert.valor | number : "1.0-2" : "es" }}</label>
							</div>
						</div>
					</div>
				</div>
				<div id="wizStepFormaPago">
					<!-- Certificado digital adicional -->
					<div *ngIf="compraCertificado?.comprar" class="my-3">
						<strong class="d-block text-color-dark mb-2">Certificado Digital</strong>
						<div class="d-flex justify-content-between align-items-center flex-wrap">
							<div class="d-flex align-items-center">
								<label class="mb-0 mr-2">Duración:</label>
								<select class="form-control w-auto" [(ngModel)]="compraCertificado.duracion" (change)="onChangeDuracion()">
									<option [ngValue]="1">1 año</option>
									<option [ngValue]="2">2 años</option>
									<option [ngValue]="3">3 años</option>
								</select>
							</div>
							<div>
								<button type="button" class="btn btn-link text-danger p-0" (click)="eliminarCertificadoDigital()"><i class="fas fa-trash-alt"></i> Eliminar</button>
							</div>
						</div>
						<div class="form-check mt-2">
							<input type="checkbox" class="form-check-input" id="chkGarantia" [(ngModel)]="compraCertificado.garantia" (change)="onCheckBoxGarantia()" />
							<label class="form-check-label" for="chkGarantia">Añadir Garantía de Recuperación</label>
							<span class="ml-2 price-label">{{ compraCertificado.precioGarantia | currency : "CLP" : "symbol" : "1.0-0" : "es" }} + IVA</span>
						</div>
					</div>

					<!-- Formas de Pago -->
					<div class="mt-3">
						<strong class="d-block text-color-dark mb-2">Formas de Pago</strong>
						<div class="form-group row mx-auto" style="align-items: baseline">
							<div class="custom-control custom-radio custom-control-inline">
								<input type="radio" id="radiowebpay" [attr.data-testid]="type + '-payment-webpay'" class="custom-control-input" name="formaPago" value="webpay" [checked]="formaPago == 'webpay' || type == 'paymentBlocked' || type === 'certifications'" (change)="updateFormaPago($event.target.value)" />
								<label class="custom-control-label" for="radiowebpay">WebPay</label>
							</div>
							<div class="custom-control custom-radio custom-control-inline" *ngIf="type !== 'certifications'">
								<input type="radio" id="radiofree" name="formaPago" class="custom-control-input" value="free" [disabled]="type == 'extend' || type == 'change'" [checked]="formaPago == 'free'" (change)="updateFormaPago($event.target.value)" />
								<label class="custom-control-label" for="radiofree">Usaré los 7 dias gratuitos</label>
							</div>
						</div>
					</div>

					<!-- Adicionales -->
					<div class="mt-3" *ngIf="type !== 'certifications' && !esDemoGratis()">
						<strong class="d-block text-color-dark mb-2">Adicionales</strong>
						<div class="form-group row mx-auto" style="align-items: baseline">
							<div class="checkbox-list plan-price">
								<label style="margin-bottom: 3px" class="checkbox" [ngClass]="{ 'checkbox-disabled': adicionalSinMensajePDF.readOnly }">
									<input type="checkbox" name="Checkboxes1" id="checkboxMensaje" [attr.data-testid]="type + '-additional-pdf'" [(ngModel)]="adicionalSinMensajePDF.checked" [disabled]="adicionalSinMensajePDF.readOnly" (change)="actualizarCalculos()" />
									<span></span>Sin mensaje de SimpleFactura en PDF
									<i class="fa fa-question-circle ml-1" ngbTooltip="El PDF que recibe tu cliente se genera sin la leyenda 'Creado con SimpleFactura.'" container="body"></i></label
								><label class="price-label" [attr.data-testid]="type + '-additional-pdf-message'">{{ adicionalSinMensajePDF.message }}</label>
								<label style="margin-bottom: 4px; margin-top: 10px" class="checkbox" [ngClass]="{ 'checkbox-disabled': adicionalAccesoDTERecibido.readOnly }">
									<input type="checkbox" checked="checked" id="checkboxRecibidos" name="Checkboxes1" [attr.data-testid]="type + '-additional-received'" [(ngModel)]="adicionalAccesoDTERecibido.checked" [disabled]="adicionalAccesoDTERecibido.readOnly" (change)="actualizarCalculos()" />
									<span></span>Acceso a DTEs Recibidos
									<i class="fa fa-question-circle ml-1" ngbTooltip="Habilita la bandeja de documentos recibidos de proveedores para llevar control de tus compras. Consultamos al SII y a la casilla de intercambio." container="body"></i></label
								>
								<label class="price-label" [attr.data-testid]="type + '-additional-received-message'">{{ adicionalAccesoDTERecibido.message }}</label>
								<label style="margin-bottom: 4px; margin-top: 10px" class="checkbox" [ngClass]="{ 'checkbox-disabled': adicionalPayku.readOnly }" ngbTooltip="{{ adicionalPayku.descripcion }}">
									<input type="checkbox" checked="checked" id="checkboxPayku" name="CheckboxesPayku" [(ngModel)]="adicionalPayku.checked" [disabled]="adicionalPayku.readOnly" (change)="actualizarCalculos()" />
									<span></span>Link de Pago Payku
									<i class="fa fa-question-circle ml-1" ngbTooltip="Habilita Link/QR de pago en tus documentos emitidos." container="body"></i></label
								>
								<label class="price-label">{{ adicionalPayku.message }}</label>
							</div>
						</div>
					</div>

					<!-- Cupón -->
					<div class="mt-3" *ngIf="type !== 'certifications'">
						<strong class="d-block text-color-dark mb-2">Cupón Promocional</strong>
						<div style="display: inline-block; vertical-align: top">
							<input #inputCodigoDescuento [attr.data-testid]="type + '-coupon'" type="text" (blur)="updateCupon(inputCodigoDescuento.value)" style="border: 1px solid #e4e6ef; border-radius: 0.42rem; width: 100%" />
						</div>
						<div *ngIf="cupon" style="display: inline-block">
							<i *ngIf="cupon.activo">
								<small>${{ cupon.descuento | number : "1.0-2" : "es" }}</small>
							</i>
						</div>
						<div *ngIf="!cupon && inputCodigoDescuento.value.length > 0" style="display: inline-block">
							<i>
								<small>{{ mensajeCupon }}</small>
							</i>
						</div>
					</div>

					<!-- Tiempo de contratación -->
					<div class="mt-3" *ngIf="type !== 'certifications'">
						<strong class="text-color-dark">Tiempo de contratación</strong>
						<p class="mb-1" id="textMeses" [attr.data-testid]="type + '-months-value'">Meses: {{ nmeses }}</p>
						<input type="range" [attr.data-testid]="type + '-months'" [min]="resumenCuenta.mesesAbono || 1" max="24" [value]="nmeses" (change)="updateMes($event.target.value)" class="custom-range mb-3" />
					</div>

					<!-- Totales -->
					<div
						class="totales-block mt-4"
						[attr.data-testid]="(type === 'certifications' ? 'certification' : type) + '-quotation'"
						[attr.data-quotation-id]="resumenCuenta?.cotizacionId"
						[attr.data-quotation-total]="resumenCuenta?.total"
					>
						<div *ngIf="type == 'wizard'" class="d-flex justify-content-between py-2">
							<div class="text-color-dark">Fecha de Término:</div>
							<div>
								<span class="amount font-weight-medium" id="fechaPlanes">{{ resumenCuenta.fechaTermino | date : "dd/MM/yyyy" }}</span>
							</div>
						</div>
						<div class="d-flex justify-content-between py-1" *ngIf="resumenCuenta?.proporcional > 0">
							<strong class="text-color-dark">Proporcional ({{ resumenCuenta?.differenceInDays }} días):</strong>
							<strong>
								$<span class="amount font-weight-medium" id="textPlanes" [attr.data-testid]="type + '-summary-proportional'">{{ resumenCuenta.proporcional | number : "1.0-2" : "es" }}</span>
							</strong>
						</div>
					<div class="d-flex justify-content-between py-1" *ngIf="type !== 'certifications'">
							<strong class="text-color-dark">Planes:</strong>
							<strong>
								$<span class="amount font-weight-medium" id="textPlanes" [attr.data-testid]="type + '-summary-plans'">{{ resumenCuenta.totalPlanes | number : "1.0-2" : "es" }}</span>
							</strong>
						</div>
					<div class="d-flex justify-content-between py-1" *ngIf="type !== 'certifications'">
							<strong class="text-color-dark">Adicionales:</strong>
							<strong>
								$<span class="amount font-weight-medium" id="textAdicionales" [attr.data-testid]="type + '-summary-additionals'">{{ resumenCuenta.totalAdicionales | number : "1.0-2" : "es" }}</span>
							</strong>
						</div>
					<div class="d-flex justify-content-between py-1" *ngIf="type !== 'certifications'">
							<strong class="text-color-dark">Certificaciones (P. único):</strong>
							<strong>
								$<span class="amount font-weight-medium" id="textCertificaciones">{{ resumenCuenta.totalCertificaciones | number : "1.0-2" : "es" }}</span>
							</strong>
						</div>
						<div class="d-flex justify-content-between py-1" *ngIf="compraCertificado?.comprar">
							<strong class="text-color-dark">Certificado Digital (P. único):</strong>
							<strong>
								$<span class="amount font-weight-medium" id="textCertificado">{{ compraCertificado.total | number : "1.0-0" : "es" }}</span>
							</strong>
						</div>
					<div class="d-flex justify-content-between py-1">
							<strong class="text-color-dark">Subtotal:</strong>
							<strong>
								$<span class="amount font-weight-medium" id="textSubtotal" [attr.data-testid]="(type === 'certifications' ? 'certification' : type) + '-summary-subtotal'">{{ resumenCuenta.subtotal | number : "1.0-2" : "es" }}</span>
							</strong>
						</div>
						<app-saldo-favor-bloque
							[total]="resumenCuenta?.total || 0"
							[maximoElegible]="totalElegibleSaldo"
							[planUsuario]="planUsuario"
							[permitirTitularSinPlan]="type === 'wizard'"
							[disabled]="formaPago === 'free' && !compraCertificado?.comprar"
							(seleccionChange)="actualizarSaldoFavor($event)"
						></app-saldo-favor-bloque>
					<div class="d-flex justify-content-between py-1" *ngIf="type !== 'certifications'">
							<strong class="text-color-dark" id="textDescuentoPorc">Descuento ({{ resumenCuenta.descuentoPorc }}%):</strong>
							<strong>
								$<span class="amount font-weight-medium" id="textDescuento" [attr.data-testid]="type + '-summary-discount'">{{ resumenCuenta.descuento | number : "1.0-2" : "es" }}</span>
							</strong>
						</div>
						<div class="d-flex justify-content-between py-1" *ngIf="resumenCuenta.abono">
							<strong class="text-color-dark"> Abono: </strong>
							<strong>
								$<span class="amount font-weight-medium" [attr.data-testid]="type + '-summary-credit'">{{ resumenCuenta.abono | number : "1.0-0" : "es" }}</span>
							</strong>
						</div>
						<div class="d-flex justify-content-between py-1">
							<strong class="text-color-dark">Neto:</strong>
							<strong>
								$<span class="amount font-weight-medium" id="textNeto" [attr.data-testid]="(type === 'certifications' ? 'certification' : type) + '-summary-net'">{{ netoPagarConSaldo | number : "1.0-2" : "es" }}</span>
							</strong>
						</div>
						<div class="d-flex justify-content-between py-1">
							<strong class="text-color-dark">IVA:</strong>
							<strong>
								$<span class="amount font-weight-medium" id="textIVA" [attr.data-testid]="(type === 'certifications' ? 'certification' : type) + '-summary-vat'">{{ ivaPagarConSaldo | number : "1.0-2" : "es" }}</span>
							</strong>
						</div>
						<div class="d-flex justify-content-between py-2">
							<strong class="text-color-dark">Total a pagar:</strong>
							<strong class="text-color-dark">
								$<span class="amount text-color-dark text-5" id="textTotal" [attr.data-testid]="(type === 'certifications' ? 'certification' : type) + '-summary-total'">{{ totalPagarConSaldo | number : "1.0-2" : "es" }}</span>
							</strong>
						</div>
					</div>
				</div>
			</div>
			<table class="shomb-3" *ngIf="!planSeleccionado && type != 'certifications'">
				<tbody>
					<tr>
						<td class="td_shop">
							<strong class="d-block text-color-dark line-height-1 font-weight-semibold" id="nombrePlan">Debe seleccionar un plan para continuar</strong>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</ng-template>
